/**
 * Constants Values used in applicaiton, ordered in Alpabatically
 */
export const AppConstants = {
    BUSINESSLOCATIONS: 'businesslocations',
    ROLES_REQUIRED: 'rolesRequired',
    COSTCENTERS: 'costcenters',
    DAYSOFFSET: 'daysoffset',
    GETREQUEST: 'get',
    POSTREQUEST: 'post',
    DELETEREQUEST: 'delete',
    ROUTES: 'routes',
    ADDRESSPOINT:'addresses',
    AIRRECIPIENT:'legacy-id-resolver/lookup',
    IDENTITY:'identity',
    Command:'command',
    DP:'dp',
    V1:'v1',
    V4:'v4',
    GPS:'gps',
    RPS: 'rps',
    Address:'address',
    PAMROUTES: 'pamroutes',
    Vehicles : 'vehicleregistrationnumber',
    OperationalVehicles: 'operationalvehicles',
    Workshifts :'workshifts',
    USER_PREFERENCES: 'preferences',
    SAVE_PREFERENCES: 'savePreferences',
    DELETE_PREFERENCES: 'deletePreference',
    DELETE_MESSAGE: 'Are you sure you want to delete this favorite list?',
    DELETE_CONFIRMATION: 'Delete Confirmation',
    OPTIMIZATION_DETAILS: 'optimizationDetails',
    PREFERENCE: 'preferences',
    DELETE_PREFERENCE: 'deletePreference',
    USER: 'user',
    POST_PREFERENCE_USER: 'savePreferences',
    REPORTS: 'reports',
    SAVE_REPORT: 'savereport',
    DELETE_REPORT: 'deletereport',
    REPORT_DELETE_MESSAGE: 'Are you sure you want to delete this report?',
    CATEGORIES :'categories',
    GET_SORTING_IMAGES: 'getSortingImages',
    TASKS: 'tasks',
    INCOMPLETE: 'incomplete',
    ITEMSDETAILS_MOVED_IN: 'MOVED_IN',
    ITEMSDETAILS_MOVED_OUT: 'MOVED_OUT',
    ITEMSDETAILS_PLANNED_AFTER_LOADSTART: 'PLANNED_AFTER_LOADSTART',
    SERVICEPOINT: 'servicepoints',
    POSTPARCELBOXREPORT:  'postparcelboxreport',
    DKINFO: 'gql/expression/dk_info_message',
    SEINFO: 'gql/expression/se_info_message',
    CONSEQUENCES: 'consequences',
    DPOPTIMIZATION:'dpOptimize',
    TRANSACTION_TYPE:'transactionType',
    TYPE:'type',
    APPROACH_TYPE:'approachType',
    COMPLETE_CONFIRMATION: 'Route update confirmation',
    COMPLETE_ROUTE: 'Are you sure want to complete this route?',
    DELETE_USER_PREFERENCE: 'Are you sure you want to delete this Column Preference?',
    DELETE_ROUTE_PREFERENCE_MESSAGE: 'Are you sure you want to delete this custom route preference?',
    RPS_OPTIMIZATION_MESSAGE: 'Are you sure you want to proceed?',
    RPS_OPTIMIZATION_CONFIRMATION: 'RPS Optimization Confirmation',
    SLOT_IN_MESSAGE: 'Are you sure you want to proceed?',
    SLOT_IN_CONFIRMATION: 'Slot in Confirmation',
}
/**
 * Messaging Constants Values used in applicaiton
 */
export const MessageConstants = {
    PULLBACKCONFIRMATION:'Are you sure you want to pullback to unplanned pickup?',
    HEADER:'Confirmation'
}

export const AccessRoles = {
    GLOBALADMINISTRATOR: 'GlobalAdministrator',
    ADMINISTRATOR: 'Administrator',
    MANAGER: 'Manager',
    INTELLIGENCE: 'Intelligence',
    GLOBALINTELLIGENCE: 'GlobalIntelligence',
    SUPERUSER: 'SuperUser'
}

export const CountryCode = {
    Denmark : 'DK',
    Sweden : 'SE'
}

export const IntervalDuration = {
    ROUTEINFODELTA : (1 * 60 * 1000),
    ROUTEINFO: (10 * 60 * 1000),
    TASKDELTA : (1 * 60 * 1000),
    GPSDELTA : (1 * 60 * 1000)
}